import { daysOfTheWeekP, months, typesOfPreaching } from '@monorepo/helpers';
import { FC } from 'react';
import { helpers } from '@/services';
import { useGetCurrentUser } from '@/custom-hooks';

type propsType = {
};

export const UserAssignmentsPublicMinistry: FC<propsType> = ({ }) => {
    const user = useGetCurrentUser();

    return (
        <div className={'my-2'}>
            <h3 className={'mb-3'}>
                Asignaciones del Servicio del Campo:
            </h3>
            {!!user.publicMinistryAssignments?.filter(a => new Date(a.year, a.month) >= new Date(new Date().getFullYear(), new Date().getMonth())).length ?
                (user.publicMinistryAssignments
                    .filter(a => new Date(a.year, a.month) >= new Date(new Date().getFullYear(), new Date().getMonth()))
                    .map(a =>
                        <div key={a.id}>
                            <h5>
                                {months[a.month - 1]} {a.year}
                            </h5>
                            <p>
                                {a.isCircuitOverseer && '|VISITA|'} CONDUCTOR{a.captain2?.id === user.id ? ' SUPLENTE:' : ':'} {a.weekday !== null ? `Los ${daysOfTheWeekP[a.weekday]}` : `El ${helpers.GetDayOfWeekFromDateString(`${a.year}-${a.month}-${a.day}`)} ${a.day}`} a las {String(a.hour).padStart(2, '0')}:{String(a.minutes).padStart(2, '0')} hs. {a.address1 && `desde ${a.address1}`} {a.address2 && `o desde ${a.address2}`} ({typesOfPreaching.find(tp => tp.type === a.typeOfPreaching)?.label}) {a.groups && `, grupos ${a.groups.join(', ')}; ${!!a.territories.length && `territorios ${a.territories.join(', ')}`}`}
                            </p>
                        </div>
                    )
                )
                :
                <h4>
                    Ninguna
                </h4>
            }
        </div>
    );
}
